import React, { FC } from 'react';

import { Flex } from '../Flex';

import { Contact } from './Contact';
import { Faqs } from './Faqs';
import s from './index.module.scss';

import { useTranslation } from '#root/hooks/use-translation';
import { Keys } from '#root/translations-keys';

export const Help: FC = () => {
  const t = useTranslation();

  return (
    <>
      <div className={s.container}>
        <div>
          <h2 className="size-m font-sans">{t(Keys.help.faq.title)}</h2>
          <Faqs />
        </div>
        <div>
          <h2 className="size-m font-sans">{t(Keys.help.contact.title)}</h2>
          <Flex outlined>
            <Contact />
          </Flex>
        </div>
      </div>
    </>
  );
};
